import { useDevLogger } from '@/composables/useDevLogger';
import { prefersReducedMotion } from '@/helpers/prefersReducedMotion';
import { viewTransitionsApiAvailable } from '@/helpers/viewTransitionsApiAvailable';

type ViewTransitionReturnValue = {
  finished: Promise<boolean>;
  ready: Promise<boolean>;
  updateCallbackDone: Promise<boolean>;
};

export function useViewTransition (
  callback: () => void,
  enabled: boolean = true,
): ViewTransitionReturnValue {
  const devLogger = useDevLogger();

  if (viewTransitionsApiAvailable && !prefersReducedMotion() && enabled) {
    devLogger.log('%c✨ View transition initiated', 'color: lightslategrey;');

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const promise = (document as any).startViewTransition(callback) as ViewTransitionReturnValue;

    promise.ready.then(() => {
      devLogger.log('%c✨ View transition ready', 'color: lightskyblue;');
    });

    promise.finished.then(() => {
      devLogger.log('%c✨ View transition finished', 'color: greenyellow;');
    });

    return promise;
  }
  else {
    callback();

    // Mock return value of document.startViewTransition.
    return {
      finished: new Promise((res) => res(true)),
      ready: new Promise((res) => res(true)),
      updateCallbackDone: new Promise((res) => res(true)),
    };
  }
}
